<script setup lang="ts">
import { ArrowDownUp } from 'lucide-vue-next'

// Exchange form: crypto in, som out; no rates so nothing reads as a quote
const { t } = useI18n()

const coins = [
  { symbol: 'BTC', tone: 'bg-orange-500' },
  { symbol: 'ETH', tone: 'bg-indigo-500' },
  { symbol: 'USDT', tone: 'bg-emerald-500' }
]
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="HeroIllustrationCard space-y-1.5">
      <div class="font-serif text-xl font-bold">{{ t('widget.hero_banner.illustration.crypto.exchange') }}</div>

      <div class="flex items-center justify-between rounded-xl bg-blue-50 px-3 py-2.5">
        <span class="text-sm text-gray-500">{{ t('widget.hero_banner.illustration.crypto.give') }}</span>
        <span class="flex items-center gap-2 font-semibold">
          <span class="grid size-6 place-items-center rounded-full bg-emerald-500 text-[0.625rem] font-bold text-white">₮</span>
          USDT
        </span>
      </div>

      <div class="relative h-0">
        <span class="absolute left-1/2 top-1/2 grid size-8 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-blue-600 text-white ring-4 ring-white">
          <ArrowDownUp class="size-4" />
        </span>
      </div>

      <div class="flex items-center justify-between rounded-xl bg-blue-50 px-3 py-2.5">
        <span class="text-sm text-gray-500">{{ t('widget.hero_banner.illustration.crypto.get') }}</span>
        <span class="font-semibold">{{ t('widget.hero_banner.illustration.som') }}</span>
      </div>
    </div>

    <div class="absolute -right-6 -top-6 flex -space-x-2">
      <span
        v-for="coin in coins"
        :key="coin.symbol"
        class="grid size-12 place-items-center rounded-full text-xs font-bold text-white shadow-lg ring-4 ring-blue-50"
        :class="coin.tone"
      >
        {{ coin.symbol }}
      </span>
    </div>
  </div>
</template>
